<template>
  <div>
    <div class="wi-100x ht-100x pf lf-0 tp-0 z-1000" v-if="loading">
      <fo-loading @finishCallback="finishCallback"></fo-loading>
    </div>
    <fo-navmenu
      :iconColor="iconColor"
      :backColor="backColor"
      :textColor="textColor" />
    <fo-pageTitle
      type="works"
      :subtitle="worksLittleTitle"
      :title="worksTitle" />
    <fo-workItems />
    <fo-slogan />
    <fo-bottom />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Works',
  computed: {
    ...mapGetters([
      'scrollTop',
      'screenWidth',
      'screenHeight',
      'sloganInfo',
      'refresh',
      'scrollHeight'
    ])
  },
  data () {
    return {
      loading: false,
      textColor: '',
      backColor: '',
      iconColor: '',
      worksTitle: '',
      worksLittleTitle: ''
    }
  },
  watch: {
    sloganInfo (val) {
      if (this.$.s2o(val).works_title) {
        this.worksTitle = this.$.s2o(val).works_title
      }
      if (this.$.s2o(val).works_small_character) {
        this.worksLittleTitle = this.$.s2o(val).works_small_character
      }
    },
    scrollTop () {
      this.setColor()
    },
    refresh (val) {
      if (val) {
        this.loading = true
      }
    }
  },
  mounted () {
    if (this.refresh) {
      this.loading = true
    }
    if (this.sloganInfo && this.$.s2o(this.sloganInfo).works_title) {
      this.worksTitle = this.$.s2o(this.sloganInfo).works_title
    }
    if (this.sloganInfo && this.$.s2o(this.sloganInfo).works_small_character) {
      this.worksLittleTitle = this.$.s2o(this.sloganInfo).works_small_character
    }
    this.setColor()
  },
  methods: {
    finishCallback () {
      this.loading = false
      this.$store.commit('updateRefresh', false)
    },
    setColor () {
      var appHeight = document.getElementById('app').offsetHeight
      var bottomHeight = document.getElementById('bottom-compos').offsetHeight
      let cond4 = appHeight - appHeight * this.scrollHeight * 0.01 - bottomHeight + this.screenHeight < 0
      if (cond4) {
        this.textColor = 'white'
        this.backColor = 'white-bg'
        this.iconColor = 'black-bg'
      } else {
        this.textColor = 'black'
        this.backColor = 'black-bg'
        this.iconColor = 'white-bg'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Works.vue